module.exports = __webpack_public_path__ + "img/rechnung.91f0497.svg";